// Sprint A Phase 2: shared reply-grouping helper.
//
// Lifted verbatim (modulo the sort callback) from the inline groups defined in
// PostDetail.js:680-712 so EvidencePage and IncidentDetail render the same
// "Why that's wrong / Possible reasons / Discredited" buckets as the main
// debate page. Evidence challenges are excluded — they belong nested inside
// the parent argument card via EvidenceChallengeSection.
//
// Inputs:
//   replies: array of reply objects with { status, stance, is_definition_thread,
//            argument_type, created_at, decisive? } fields. Only top-level
//            replies should be passed (parents handle their own subtree).
//
// Returns: array of { key, icon, title, items, defaultExpanded } groups,
// filtered to non-empty buckets. Same shape PostDetail's ReplyGroupList
// already consumes — drop-in for the IncidentDetail/EvidencePage pages.

const isEvidenceChallenge = r => r.argument_type === 'evidence_challenge';

function sortGroup(arr) {
  return [...arr].sort((a, b) => {
    if (a.decisive && !b.decisive) return -1;
    if (!a.decisive && b.decisive) return 1;
    return new Date(b.created_at) - new Date(a.created_at);
  });
}

export function buildReplyGroups(topLevelReplies) {
  const r = topLevelReplies || [];
  const groups = [
    {
      key: 'definitions',
      icon: '📖',
      title: 'Definitions',
      items: sortGroup(r.filter(x => x.is_definition_thread && !isEvidenceChallenge(x))),
      defaultExpanded: true,
    },
    {
      key: 'green',
      icon: '✅',
      title: "Why that's wrong",
      items: sortGroup(r.filter(x => !x.is_definition_thread && x.status === 'green' && !isEvidenceChallenge(x))),
      defaultExpanded: true,
    },
    {
      key: 'neutral',
      icon: '🟡',
      title: "Possible reasons that's wrong",
      // 2026-05-12-e: disputed shows alongside neutral here.
      items: sortGroup(r.filter(x =>
        !x.is_definition_thread && (x.status === 'neutral' || x.status === 'disputed') && !isEvidenceChallenge(x))),
      defaultExpanded: true,
    },
    {
      key: 'red',
      icon: '🔴',
      title: 'Discredited arguments',
      items: sortGroup(r.filter(x => !x.is_definition_thread && x.status === 'red' && !isEvidenceChallenge(x))),
      defaultExpanded: false,
    },
  ];
  return groups.filter(g => g.items.length > 0);
}
